<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <div class="section big-55-height over-hide z-bigger">
      <div class="parallax parallax-top" style="background-image: url('img/gallery/10.jpg')"></div>
      <div class="dark-over-pages"></div>

      <div class="hero-center-section pages">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 parallax-fade-top">
              <div class="hero-text">Get in Touch</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rooms"
  // components: {
  //   headerNav
  // }
};
</script>
